import Cookies from 'js-cookie';

import { COOKIE_UTM_DATA } from '../global/constants';
import { UtmData } from '../types/UtmData';

const CAMPAIGN_PARAM = 'utm_campaign';
const MEDIUM_PARAM = 'utm_medium';
const SOURCE_PARAM = 'utm_source';

/** @knipignore */
export const extractUtmData = (urlParams: URLSearchParams): UtmData | null => {
  const data = {
    campaign: urlParams.get(CAMPAIGN_PARAM),
    medium: urlParams.get(MEDIUM_PARAM),
    source: urlParams.get(SOURCE_PARAM),
  };

  if (Object.values(data).every((x) => !x)) {
    return null;
  }

  return data;
};

/** @knipignore */
export const persistUtmData = (data: UtmData): void => {
  Cookies.set(COOKIE_UTM_DATA, JSON.stringify(data));
};

export const readUtmData = (): UtmData | null => {
  const json = Cookies.get(COOKIE_UTM_DATA);

  if (!json) {
    return readFallbackUtmData();
  }

  try {
    return JSON.parse(json);
  } catch (e) {
    console.error(`Failed to parse utm data json: '${json}'`);

    return null;
  }
};

// This cookie is deprecated.
const COOKIE_UTM_CAMPAIGN = 'htcUtmCampaign';

const readFallbackUtmData = (): UtmData | null => {
  const campaign = Cookies.get(COOKIE_UTM_CAMPAIGN);

  if (!campaign) {
    return null;
  }

  return {
    campaign,
    medium: null,
    source: null,
  };
};
